import { render } from "./HowToRow.vue?vue&type=template&id=6cb1fad6"
const script = {}

import exportComponent from "/var/www/html/gonapsacc-11/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__